import { useEffect } from "react";
import {
  ATTRIBUTION_MAX_AGE_SECONDS_MARKETING,
  captureAttributionFromCurrentUrl,
} from "@/lib/attribution";

/**
 * Captures marketing attribution (UTMs, referrer, inferred source) on qrhub.io
 * and stores it for 7 days so CTAs can bridge it into the dashboard signup URL.
 */
export function AttributionCapture(): null {
  useEffect(() => {
    captureAttributionFromCurrentUrl({
      maxAgeSeconds: ATTRIBUTION_MAX_AGE_SECONDS_MARKETING,
      ttlSeconds: ATTRIBUTION_MAX_AGE_SECONDS_MARKETING,
    });
  }, []);

  return null;
}
